import { getTrackingAttributes } from '@rio-cloud/rio-uikit/googleAnalyticsUtils';
import { useIntl } from 'react-intl';

import type { OrderType } from '#domain/Order.ts';
import { useLocaleManualLink } from '#hooks/shared/useLocaleManualLink.ts';

import { CreateOrderButton } from './CreateOrderButton.tsx';

type OrderEmptyStateProps = {
    onOpenCreateOrderDialog: (type?: OrderType) => void;
};

export const OrderEmptyState = ({ onOpenCreateOrderDialog }: OrderEmptyStateProps) => {
    const intl = useIntl();
    const manualLink = useLocaleManualLink();

    return (
        <div data-testid='order-empty-state' className='display-flex justify-content-center max-width-100pct'>
            <div className='margin-0 width-100pct max-width-600 panel-default panel padding-15 border-none'>
                <div className='display-flex flex-column align-items-center text-center padding-25'>
                    <div className='text-size-h3 text-size-h2-xl line-height-125rel text-color-dark text-medium width-500 max-width-100pct text-wrap-balance'>
                        {intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.orders.empty-state.title',
                            defaultMessage: 'No orders available',
                        })}
                    </div>
                    <div className='text-color-dark margin-top-15 width-500 max-width-100pct text-wrap-balance'>
                        {intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.orders.empty-state.message',
                            defaultMessage:
                                'Create your first order or learn the basics of Order Communication in our user manual.',
                        })}
                    </div>
                    <div className='display-flex flex-wrap justify-content-center gap-10 margin-top-20'>
                        <CreateOrderButton
                            title={intl.formatMessage({
                                id: 'intl-msg:ordercom-cloud-frontend.orders.empty-state.cta.create',
                                defaultMessage: 'Create first order',
                            })}
                            onSelect={onOpenCreateOrderDialog}
                        />
                        <a
                            href={manualLink}
                            target='_blank'
                            rel='noreferrer'
                            className='btn btn-default'
                            {...getTrackingAttributes({
                                trigger: 'click',
                                category: 'link autoTracking',
                                action: 'link click',
                                label: 'intl-msg:ordercom-cloud-frontend.orders.empty-state.cta.manual',
                            })}
                        >
                            <span className='uikit-icon icon-question-sign margin-right-5' aria-hidden='true' />
                            {intl.formatMessage({
                                id: 'intl-msg:ordercom-cloud-frontend.orders.empty-state.cta.manual',

                                defaultMessage: 'User manual',
                            })}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
